import { createSelector } from 'reselect';
import { ReportKey, ReportsDataMap } from '@models/interfaces';
import { AppState } from '../reducers';
import {
  getReportsFilterHash,
  ReportsState,
} from '../reducers/reports.reducer';

const reportsState = (state: AppState): ReportsState => state.reports;

export namespace ReportsSelectors {
  export const getReportsState = createSelector(
    [reportsState],
    (store: ReportsState) => store,
  );

  export const getData = createSelector(
    [reportsState],
    (store: ReportsState): Partial<ReportsDataMap> => store.data,
  );

  export const getFilterOptions = createSelector(
    [reportsState],
    (store: ReportsState) => store.filterOptions,
  );

  export const getFilters = createSelector(
    [reportsState],
    (store: ReportsState) => store.filters,
  );

  export const getSelectedReport = createSelector(
    [reportsState],
    (store: ReportsState) => store.selectedReport,
  );

  export const getCurrentFilterHash = createSelector(
    [reportsState],
    (store: ReportsState) => getReportsFilterHash(store.filters),
  );

  export const getCurrentReportData = createSelector(
    [reportsState],
    (store: ReportsState) => store.data[store.selectedReport],
  );

  export const getCurrentReportError = createSelector(
    [reportsState],
    (store: ReportsState): boolean => !!store.errors[store.selectedReport],
  );

  export const getCurrentReportLoading = createSelector(
    [reportsState, getCurrentFilterHash],
    (store: ReportsState, currentFilterHash: string): boolean =>
      !!store.loadingReports[store.selectedReport] &&
      store.loadingReportHashes[store.selectedReport] === currentFilterHash,
  );

  export const getFilterOptionsLoading = createSelector(
    [reportsState],
    (store: ReportsState): boolean => store.filterOptionsLoading,
  );

  export const getFilterOptionsError = createSelector(
    [reportsState],
    (store: ReportsState): boolean => store.filterOptionsError,
  );

  export const isCurrentReportLoaded = createSelector(
    [reportsState, getCurrentFilterHash],
    (store: ReportsState, currentFilterHash: string): boolean =>
      store.loadedReports[store.selectedReport] === currentFilterHash,
  );

  export const isReportLoaded = (reportKey: ReportKey) =>
    createSelector(
      [reportsState, getCurrentFilterHash],
      (store: ReportsState, currentFilterHash: string): boolean =>
        store.loadedReports[reportKey] === currentFilterHash,
    );
}
